import { Children, createElement, type ComponentType, type ReactNode } from 'react';

/**
 * 안내 문장을 문장마다 줄바꿈 — 한국어 문장 끝("요." "다." "요?" "다!" 등, 끝말 뒤 괄호 하나까지 "있어요(마감 …).") 뒤 공백을 "\n" 으로 바꾼다.
 * 숫자·날짜 안 마침표("1.5", "10/29(목)")는 문장 끝 글자(다·요) 뒤가 아니라서 나누지 않는다. 이미 들어 있는 "\n" 은 그대로 둔다.
 * 문장 뒤에 붙는 괄호 설명("기다리는 중이에요. (마감 …)")은 앞 문장에 붙여 둔다.
 * 그리는 쪽은 white-space: pre-line 이어야 줄이 바뀐다. 줄 사이는 그 글의 줄 간격 그대로(여백을 더하지 않는다).
 */
export const breakSentences = (text: string): string => text.replace(/([다요](?:\([^()\n]*\))?[.!?])[ \t]+(?=[^\s(])/g, '$1\n');

/** 자식 중 글자 조각만 문장마다 줄바꿈(굵은 글씨 등 요소는 그대로) */
export const sentenceLines = (node: ReactNode): ReactNode => {
    if (typeof node === 'string') return breakSentences(node);
    if (!Array.isArray(node)) return node;
    return Children.map(node, (child: ReactNode) => (typeof child === 'string' ? breakSentences(child) : child));
};

/**
 * 안내 문장 부품을 "문장마다 줄바꿈" 부품으로 감싼다 — 대화방 카드 Note·시트 SheetHelp·결과 상자 등 한 곳에서 처리하려고.
 * 감싸는 부품은 white-space: pre-line 이어야 한다.
 */
export const withSentenceLines = <P extends { children?: ReactNode }>(Base: ComponentType<P>): ComponentType<P> => {
    const Wrapped = (props: P) => createElement(Base, props, sentenceLines(props.children));
    Wrapped.displayName = `SentenceLines(${Base.displayName ?? Base.name ?? '부품'})`;
    return Wrapped;
};
